import React, { useEffect, useState } from 'react'
import { css } from '../../../services/css'
import { Button } from '../inputs/button'
import { Portal } from '../portal/portal'

import styles from './modal.module.css'

/**
 * @param {Object} props
 * @param {string} [props.header=''] Header
 * @param {React.ReactNode} props.children Contents
 * @param {{
 *  label: string,
 *  primary?: boolean,
 *  closeOnClick?: boolean,
 *  className?: string,
 *  onClick?: (e: MouseEvent) => void,
 *  disabled?: boolean
 * }[]} [props.buttons={label: 'Ok', primary: true, closeOnClick: true, className: null}] Buttons
 * @param {string|null} [props.width=null] Width
 * @param {boolean} props.active Is it shown
 * @param {boolean} [props.aotRendering=true] Should it be rendered and hidden with styles asap
 * @param {function(): void} [props.onClose] Called when closed
 */
export const Modal = ({
    header = '',
    children,
    width = null,
    buttons=[{label: 'Ok', primary: true, closeOnClick: true}],
    active,
    aotRendering = false,
    onClose = () => { throw 'Modal must have an onClose event to close' }
}) => {

    /*

        active (from props): Controlled by the parent. Trigger animations and directly controls interactivity
        render: Controlled by active and aotRendering, Controls the dom existence of the modal
        shown: Controlled by render or active, Controls is the modal is shown

    */

    const [render, setRender] = useState(aotRendering);
    const [shown, setShown] = useState(false);
    const [ingoreClick, setIngoreClick] = useState(false);

    const handleClick = (buttonData, e) => {
        if (buttonData.onClick) buttonData.onClick(e);
        if (buttonData.closeOnClick) onClose();
    }

    const btnAttr = (buttonData) => {
        let {label, primary, closeOnClick, ...props} = buttonData;

        return props;
    }

    useEffect(() => {
        if (active) {
            setRender(true);
        } else {
            setShown(false);

            if (!aotRendering)
                window.setTimeout(() => {setRender(false)}, 300);
        }
    }, [active]);

    useEffect(() => {
        if (render && active && render != shown)
            //Wait for the next frame, after the render is completed
            window.requestAnimationFrame(() => {setShown(true);})
    }, [render, active]);

    const handlePointerUp = () => {
        if (!ingoreClick) onClose();
        setIngoreClick(false);
    }


    return render ?
        <Portal>
            <div
                className={css(styles.ModalWrapper, shown && styles.Shown, active && styles.Active)}
                onPointerUp={handlePointerUp}
            >
                <div
                    className={styles.Modal}
                    style={{
                        width: width
                    }}
                    onPointerDown={e => { setIngoreClick(true); }}
                >
                    <header>
                        {header}
                    </header>
                    <main>
                        {children}
                    </main>
                    <footer>
                        {
                            buttons.map(b =>
                                <Button
                                    key={b.label}
                                    {...btnAttr(b)}
                                    className={css(b.className, 'shadow', b.primary && 'primary')}
                                    onClick={(e) => { handleClick(b, e); }}
                                >{b.label}</Button>
                            )
                        }
                    </footer>
                </div>
            </div>
        </Portal>
        : <></>;
}